<Panel flex items="start" justify="start" p="xs">

  <Panel overflow="hidden" pb="xs" mr="xs">
    <Icon name="xls" size="xl" bg="light" color="dark--" w=2.25 h=2.25 round noborder="3"/>
  </Panel>

  <Panel grow ml="sm"> 
    <Text 
      color="body" line="ample"
      font-size={template && template.name ? 'sm' : 'nm'}
      >
      {
        template && template.name 
        ?  "Plantilla: "+template.name 
        : 'No hay una plantilla definida para este reporte'
      }
    </Text>
    <br>
    <Button 
      on:click={() => selectFiles()}
      bg="light"
      color="primary++"
      border="0"
      mt="xs"
      xs bold p="sm"
      hover="injector-add-button-hover"
      pointer
      >
      <Icon name="upload" size="nm" />
      {
        template && template.name 
        ? 'Sube otra plantilla'
        : 'Sube una plantilla'
      }
    </Button>

    <input 
      style="display:none;"
      type="file"
      on:change={uploadTemplate}
      id={uploader}
      />
  </Panel>

</Panel>

<script>
  import { tick, createEventDispatcher } from 'svelte'
  import API from '@/api'
  import { cloned, randid } from '@/helpers'
  import { Panel, Icon, Button, Text } from 'svelte-stylo'

  export let 
    rpt;

  let 
    uploader = randid(),
    uploaded = '',
    template = null,
    emit = createEventDispatcher();

  $: if (rpt && rpt.definition && rpt.definition.template_file) {
    template = rpt.definition.template_file;
    template.url = API.url("/reports/"+rpt.id, {'t': API.token()});    
  }

  function selectFiles() {
    let hiddenLink = document.getElementById(uploader);
    hiddenLink.click();
  }

  async function uploadTemplate(ev) {
    const files = ev.target.files;
    if (files && files[0]) {
      try {
        uploaded = "Subiendo el archivo ...";
        await tick();

        let rsp = await API.reportDefs.upload(rpt.id, files[0])
        rpt.definition.template_file = rsp ;
        uploaded = "Subimos: "+rsp.name;
        emit('changed'); // emit a message that template changed !

        // reset after upload 
        await tick();
        document.getElementById(uploader).value = "";
      }
      catch (err) {
        console.log("problema al subir archivo", err);
        console.log("ReportDefEditor upload err=", err);
        uploaded = "Falló la subida !";
      }
    }
  }
</script>


